module.exports = __webpack_public_path__ + "img/ms-logo.319d9b9a.svg";